import reduxUtils from 'src/utils/reduxUtils';
import constants from 'src/constants';

const { EMAIL_STATES } = constants.jobShare;

const initialState = {
  emailState: EMAIL_STATES.notReadyToSend.id,
  isJobShareLoading: false,
  jobShareData: null,
};

const namespace = 'DESIGN_PRO/JOB_SHARE';
const generateActionType = reduxUtils.generateActionType.bind(null, namespace);

const actionTypes = {
  UPDATE_IS_JOB_SHARE_LOADING: generateActionType(
    'UPDATE_IS_JOB_SHARE_LOADING',
  ),
  UPDATE_JOB_SHARE_EMAIL_STATE: generateActionType(
    'UPDATE_JOB_SHARE_EMAIL_STATE',
  ),
  RECEIVE_JOB_SHARE_DATA: generateActionType('RECEIVE_JOB_SHARE_DATA'),
  CREATE_JOB_SHARE: generateActionType('CREATE_JOB_SHARE'),
  CREATE_JOB_SHARE_BEGIN: generateActionType('CREATE_JOB_SHARE_BEGIN'),
  CREATE_JOB_SHARE_END: generateActionType('CREATE_JOB_SHARE_END'),
  SEND_JOB_SHARE_EMAIL: generateActionType('SEND_JOB_SHARE_EMAIL'),
  SEND_JOB_SHARE_EMAIL_BEGIN: generateActionType('SEND_JOB_SHARE_EMAIL_BEGIN'),
  SEND_JOB_SHARE_EMAIL_END: generateActionType('SEND_JOB_SHARE_EMAIL_END'),
  RESET_JOB_SHARE_EMAIL_STATE: generateActionType(
    'RESET_JOB_SHARE_EMAIL_STATE',
  ),
};

const actions = {
  createJobShare: () => ({ type: actionTypes.CREATE_JOB_SHARE }),
  createJobShareBegin: () => ({ type: actionTypes.CREATE_JOB_SHARE_BEGIN }),
  createJobShareEnd: (data) => ({
    type: actionTypes.CREATE_JOB_SHARE_END,
    payload: { data },
  }),
  sendJobShareEmail: (email, senderText) => ({
    type: actionTypes.SEND_JOB_SHARE_EMAIL,
    payload: {
      email,
      senderText,
    },
  }),
  sendJobShareEmailBegin: () => ({
    type: actionTypes.SEND_JOB_SHARE_EMAIL_BEGIN,
  }),
  sendJobShareEmailEnd: () => ({ type: actionTypes.SEND_JOB_SHARE_EMAIL_END }),
  updateIsJobShareLoading: (isJobShareLoading) => ({
    type: actionTypes.UPDATE_IS_JOB_SHARE_LOADING,
    payload: { isJobShareLoading },
  }),
  updateJobShareEmailState: (emailState) => ({
    type: actionTypes.UPDATE_JOB_SHARE_EMAIL_STATE,
    payload: { emailState },
  }),
  resetJobShareEmailState: () => ({
    type: actionTypes.RESET_JOB_SHARE_EMAIL_STATE,
  }),
  receiveJobShareData: (jobShareData) => ({
    type: actionTypes.RECEIVE_JOB_SHARE_DATA,
    payload: { jobShareData },
  }),
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.UPDATE_IS_JOB_SHARE_LOADING:
      return {
        ...state,
        isJobShareLoading: payload.isJobShareLoading,
      };
    case actionTypes.UPDATE_JOB_SHARE_EMAIL_STATE:
      return {
        ...state,
        emailState: payload.emailState,
      };
    case actionTypes.RESET_JOB_SHARE_EMAIL_STATE:
      return {
        ...state,
        emailState: EMAIL_STATES.notReadyToSend.id,
      };
    case actionTypes.RECEIVE_JOB_SHARE_DATA:
      return {
        ...state,
        jobShareData: payload.jobShareData,
      };
    default:
      return state;
  }
};

export default {
  actionTypes,
  actions,
  reducer,
};
